
export default [

  {
    name: 'AIchat-base',
    path: 'AIchat-base',
    component: resolve => { require(['../views/oms/AIchat-base'], resolve); },
  },
  //增加名称尾-id 的路由来显示历史聊天记录
  {
    name: 'AIchat-base-id',
    path: 'AIchat-base/:id',
    component: resolve => { require(['../views/oms/AIchat-base'], resolve); },
  },
  
  {
    name: 'AIchat-enhanced',
    path: 'AIchat-enhanced',
    component: resolve => { require(['../views/oms/AIchat-enhanced'], resolve); },
  },
  {
    name: 'AIchat-enhanced-id',
    path: 'AIchat-enhanced/:id',
    component: resolve => { require(['../views/oms/AIchat-enhanced'], resolve); },
  },
]